import React from "react";
import TimePicker from "react-times";
import "react-times/css/material/default.css";
import ErrorContainer from "./ErrorContainer";
const TimeInput = ({
  label,
  formRegister,
  formError,
  formKey,
  timeVal,
  setTimeVal,
  setFormField,
  timeMode = "12",
  //
  dynamicModalElementInfo,
  setModalInfo,
  dynamicModalInfo,
}) => {
  return (
    <li>
      <div class={""}>
        <label className="required">{label}</label>
        <div class={""}>
          <TimePicker
            timeMode={timeMode}
            {...formRegister(formKey)}
            time={timeVal}
            onTimeChange={(options) => {
              const hours = options.hour;
              const minute = options.minute;
              const meridiem = options.meridiem;

              const time = `${hours}:${minute} ${meridiem}`;

              setFormField(formKey, time);
              if (!dynamicModalInfo) setTimeVal(time);
              else {
                // ! UPDATING DATE VALUE BY UPLIFTING STATE IN DYNAMIC MODAL LOCAL STATE
                // if (
                //   !(dynamicModalElementInfo && setModalInfo && dynamicModalInfo)
                // )
                //   return;

                const inputElementsArr = dynamicModalInfo?.modalElements?.map(
                  (element, idx, arr) => {
                    if (
                      element?.modalKey === dynamicModalElementInfo.modalKey
                    ) {
                      return {
                        ...dynamicModalElementInfo,
                        localStateValue: time,
                      };
                    } else return element;
                  }
                );

                setModalInfo({
                  ...dynamicModalInfo,
                  modalElements: inputElementsArr,
                });
              }
            }}
          />
          {<ErrorContainer errors={formError} name={formKey} />}
        </div>
      </div>
    </li>
  );
};

export default TimeInput;
